import React from 'react';
import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import EnlargeSvg from '../../../../public/static/icons/enlarge.svg';
import ArrowSVG from '../../../../public/static/arrow.svg';

interface IArrowIcon {
    isCollapsed: boolean;
}

// I know, I'm sad too
export const StyledOuterWrapper = styled.section``;

export const StyledInnerWrapper = styled.div`
    color: ${(props) => props.theme.shades.blackGrey};
    background-color: ${(props) => props.theme.shades.white};
    padding: 0 10px;
    margin: 0 auto;

    @media ${mediaQueries.tabletAndUp} {
        margin: 0 15px 15px 15px;
        padding: 0 10px 20px 10px;
        display: flex;
        flex-direction: column;
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        max-width: calc(100% - 30px);
        padding: 20px 10px 30px;
        margin: 0 auto;
        margin-bottom: 20px;
    }

    @media ${mediaQueries.desktopAndUp} {
        max-width: 1170px;
        padding: 20px 30px 30px;
        margin: 0 auto;
        margin-bottom: 20px;
    }
`;

export const StyledSubHeadline = styled.h3`
    font-size: 15px;
    font-weight: 700;
    line-height: 21px;
    margin: 0;
    display: block;

    @media ${mediaQueries.tabletAndUp} {
        font-size: ${(props) => props.theme.fontSize.copyTextXL};
        padding-bottom: 15px;
        font-size: ${(props) => props.theme.fontSize.headlineS};
    }
`;
export const StyledText = styled.div`
    margin: 0;
    width: 100%;
    padding: 20px 0;

    @media ${mediaQueries.tabletAndUp} {
        padding: 30px 0;
    }
`;

export const StyledParagraph = styled.p`
    font-size: ${(props) => props.theme.fontSize.copyTextL};
    line-height: 22px;
    margin-top: 0;
    margin-bottom: 0;

    @media ${mediaQueries.tabletAndUp} {
        font-size: ${(props) => props.theme.fontSize.copyTextM};
        line-height: 21px;
    }
`;

export const StyledGalleryContainer = styled.div`
    padding: 22px 0;
    @media ${mediaQueries.tabletAndUp} {
        width: 100%;
    }
`;

export const StyledRow = styled.div`
    @media ${mediaQueries.tabletAndUp} {
        display: flex;
    }
`;

export const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    padding-bottom: 10px;

    @media ${mediaQueries.tabletAndUp} {
        display: none;
    }
`;

export const StyledLabelIconContainer = styled.div`
    display: none;
    @media ${mediaQueries.tabletAndUp} {
        padding: 10px 15px 15px 0;
        margin-left: 15px;
        display: block;
        background-color: ${(props) => props.theme.labels.onlineBookable};
        width: 100%;
        max-width: calc(100% - 30px);
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        max-width: calc(100% - 30px);
        margin: 0 auto;
        padding-left: 15px;
    }
    @media ${mediaQueries.desktopAndUp} {
        max-width: 1170px;
    }
`;

export const StyledLabelIconModalContainer = styled.div`
    padding: 20px 0px 10px 0;
`;

export const StyledLabelIconList = styled.ul`
    display: flex;
    justify-content: space-evenly;
    list-style: none;
    padding-left: 10px;

    @media ${mediaQueries.tabletAndUp} {
        justify-content: flex-start;
        padding-left: 10px;
    }
`;

export const StyledLabelIconItem = styled.li`
    width: 100%;

    @media ${mediaQueries.tabletAndUp} {
        width: 25%;
        span {
            font-size: 18px;
        }
    }
`;

export const StyledHighlightsContainer = styled.div`
    display: none;
    @media ${mediaQueries.tabletAndUp} {
        width: 100%;
        display: block;
        padding: 22px 0;
    }

    @media ${mediaQueries.smallDesktopAndUp} {
        max-width: 470px;
    }

    @media ${mediaQueries.desktopAndUp} {
        max-width: 527px;
    }
`;

export const StyledHighlightsList = styled.ul`
    padding-left: 0;

    li {
        font-size: ${(props) => props.theme.fontSize.copyTextL};
        line-height: 22px;

        @media ${mediaQueries.tabletAndUp} {
            font-size: ${(props) => props.theme.fontSize.copyTextM};
            line-height: 21px;
            width: 50%;
        }

        @media ${mediaQueries.smallDesktopAndUp} {
            max-width: 470px;
            width: 33%;
        }

        @media ${mediaQueries.desktopAndUp} {
            padding-left: 10px;
            span {
                font-size: 15px;
            }
        }
    }
`;

export const StyledSuggestionBoxContainer = styled.div<{ showOnMobile: boolean }>`
    width: 100%;
    margin-bottom: 30px;

    & + & {
        margin-left: 30px;
    }

    display: ${(props) => (props.showOnMobile ? 'block' : 'none')};

    @media ${mediaQueries.tabletAndUp} {
        display: block;
        margin-bottom: 0;
    }
`;

export const StyledImage = styled.img`
    width: 100%;
    height: 100%;
`;

export const StyledImageWrapper = styled.div`
    width: 100%;
    overflow: hidden;
`;

const enlargeIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props}>
            <EnlargeSvg />
        </SvgIcon>
    );
};

export const StyledEnlargedIcon = styled(enlargeIcon)`
    position: absolute;
    right: 5px;
    width: 25px;
    height: 25px;
`;
export const StyledAspectRatio = styled.div`
    position: relative;

    &::before {
        position: relative;
        display: block;
        content: '';
        padding-bottom: calc(225 / 350 * 100%);

        @media ${mediaQueries.tablet} {
            padding-bottom: calc(263 / 350 * 100%);
        }

        @media ${mediaQueries.desktopAndUp} {
            padding-bottom: calc(263 / 527 * 100%);
        }
    }
`;

export const StyledContentWrapper = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
`;

export const StyledShowMoreBtn = styled.button`
    background-color: ${(props) => props.theme.shades.white};
    color: ${(props) => props.theme.colors.main4};
    font-size: ${(props) => props.theme.fontSize.copyTextM};
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    padding: 15px 0 15px 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 100%;

    @media ${mediaQueries.smallDesktopAndUp} {
        display: none;
    }
`;

export const StyledHighlightWrapper = styled.div`
    background-color: ${(props) => props.theme.shades.white};
    padding: 0;

    @media ${mediaQueries.smallDesktopAndUp} {
        padding: 20px 0;
    }
`;

export const StyledArrowIcon = styled(({ isCollapsed, ...rest }: IArrowIcon) => (
    <ArrowSVG {...rest} />
))`
    width: 12px;
    height: 12px;
    margin-left: 5px;
    stroke-width: 2;
    fill: ${(props) => props.theme.colors.main4};
    transform: ${(props) => (props.isCollapsed ? `rotate(90deg)` : `rotate(-90deg)`)};
`;
